var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "modal-mask" }, [
        _c(
          "div",
          {
            staticClass: "modal",
            staticStyle: { display: "block" },
            attrs: { tabindex: "-1", role: "dialog", id: "modalPopup" },
          },
          [
            _c(
              "div",
              {
                class: "modal-dialog" + " " + _vm.sizeClass,
                attrs: { role: "document" },
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c(
                    "div",
                    { staticClass: "modal-header" },
                    [
                      _vm._t("header", [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(_vm._s(_vm.innerTitle)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: { click: _vm.closeClick },
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×"),
                            ]),
                          ]
                        ),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body" },
                    [
                      _vm._t("content", [
                        _vm.innerMessage
                          ? _c("p", [_vm._v(_vm._s(_vm.innerMessage))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.innerHtmlMessage
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.innerHtmlMessage),
                              },
                            })
                          : _vm._e(),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal-footer",
                      style: {
                        display:
                          _vm.footerDisplay != null ? _vm.footerDisplay : "",
                      },
                    },
                    [
                      _vm._t("footer", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.closeClick },
                          },
                          [_vm._v("Close")]
                        ),
                      ]),
                    ],
                    2
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }